import React from "react";
import { Seo } from "../Shared/Seo/Seo.tsx";
import { findBySlug, linkableRoutes } from "../Shared/Seo/routeSeo.ts";

/**
 * Rendered for any path the router does not recognise.
 *
 * Azure serves this same content statically as /404.html with a real 404 status
 * (responseOverrides in staticwebapp.config.json), so a mistyped URL is no
 * longer a soft 404 - a 200 with an empty page, which Google reports as a crawl
 * problem. Copy comes from the shared manifest so the static file and this
 * component say the same thing.
 */
export function NotFound() {
    const entry = findBySlug("/404")!;

    return (
        <>
            <Seo entry={entry} />
            <div className="landingContent">
                <h1>{entry.h1}</h1>
                {entry.intro?.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                ))}
                <ul>
                    {linkableRoutes().map((route) => (
                        <li key={route.slug}>
                            <a href={route.slug}>{route.h1}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}

export default NotFound;
